import { Pipe, PipeTransform } from '@angular/core';
import { BoxTechnology } from '../types';
import { joinWithAnd } from './join-with-and.pipe';

@Pipe({
  name: 'boxTechnologiesNamePipe',
})
export class BoxTechnologiesNamePipe implements PipeTransform {
  public transform(boxTechnologies: BoxTechnology[]): string {
    if (boxTechnologies && boxTechnologies.length > 0) {
      return joinWithAnd(boxTechnologies.map((boxTechnology) => boxTechnology.name));
    } else {
      return null;
    }
  }
}
